import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, } from 'reactstrap';
import { useToggle, } from 'react-use';

export default function ModalButton (props) {
  const { Component = Button, label = '開く', children, title, content, modalProps, ...extraProps } = props;
  const [showsModal, toggleModal] = useToggle(false);

  return (
    <Component onClick={toggleModal.bind(null, true)} {...extraProps}>
      {children ?? label}
      {
        showsModal && (
          props.Modal ? (
            <props.Modal isOpen onClickClose={toggleModal.bind(null, false)} {...modalProps} />
          ) : (
            <Modal isOpen {...modalProps}>
              <ModalHeader>
                {title || label}
              </ModalHeader>
              <ModalBody>
                {content != null && content()}
              </ModalBody>
              <ModalFooter>
                <Button className="cancel" onClick={toggleModal.bind(null, false)}>閉じる</Button>
              </ModalFooter>
            </Modal>
          )
        )
      }
    </Component>
  );
};

